// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.32492 2.38751L15.0319 8.87259L19.9908 7.54386C21.3245 7.18651 22.6953 7.97796 23.0527 9.31163C23.41 10.6453 22.6186 12.0161 21.2849 12.3735L3.58932 17.115L0.425293 10.7159L3.59932 9.86539L5.27607 11.4867L8.61144 10.5929L4.60904 3.38318L8.32492 2.38751ZM2.00005 19H22V21H2.00005V19Z"}}]};

const FlightTakeoffFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flight-takeoff-filled',
    ref,
    icon: element,
  },
));

FlightTakeoffFilledIcon.displayName = 'FlightTakeoffFilledIcon';

export default FlightTakeoffFilledIcon;
